import { STORE_CUURENT_BRANCH_DATA, STORE_RESTRO_LIST, STORE_MARKETPLACE_SETTINGS, STORE_USER_DATA, ADD_TO_CART, REMOVE_FROM_CART, INCREASE_QUANTITY, DECREASE_QUANTITY, CLEAR_CART } from "./constant";

export const storeCurrentBranchData = (data) => {
    return {
        type: STORE_CUURENT_BRANCH_DATA,
        data
    }
}

export const storeMarketPlaceSettings = (data) => {
    return {
        type: STORE_MARKETPLACE_SETTINGS,
        data
    }
}


export const addToCart = (item) => ({
    type: ADD_TO_CART,
    payload: item,
});

export const removeFromCart = (id) => ({
    type: REMOVE_FROM_CART,
    payload: { id },
});

export const increaseQuantity = (id) => ({
    type: INCREASE_QUANTITY,
    payload: { id },
});

export const decreaseQuantity = (id) => ({
    type: DECREASE_QUANTITY,
    payload: { id },
});

export const clearCart = () => ({
    type: CLEAR_CART,
});

// export const storeUser = (data) =>{
//     return {
//         type: STORE_USER_DATA,
//         data
//     }
// }

// export const storeBusinessRestroList = (data) => {
//     return {
//         type: STORE_RESTRO_LIST,
//         data
//     }
// }



//export default storeCurrentBranchData;